import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';

const ProductCard = ({ product }) => {
  return (
    <div className="group relative flex flex-col bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300">
      <Link to={`/shop/${product.id}`} className="block relative aspect-[4/5] overflow-hidden bg-sand-light">
        {product.tags && product.tags.length > 0 && (
          <div className="absolute top-4 left-4 z-10">
            <span className="bg-sand/90 backdrop-blur-sm text-ube-dark text-xs font-medium px-3 py-1 rounded-full uppercase tracking-wider">
              {product.tags[0]}
            </span>
          </div>
        )}
        <img 
          src={product.image} 
          alt={product.altText || product.name} 
          className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700 ease-in-out" 
        />
        <div className="absolute inset-x-0 bottom-0 p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex justify-center">
          <button className="bg-white/90 backdrop-blur-md text-ube-dark font-medium py-3 px-6 rounded-full shadow-lg hover:bg-ube hover:text-white transition-colors w-full flex items-center justify-center gap-2">
            <SafeIcon name="ShoppingCart" /> Quick Add - ${product.price}
          </button>
        </div>
      </Link>
      
      <div className="p-5 flex flex-col flex-grow">
        <div className="text-xs text-gray-500 mb-1 uppercase tracking-widest">{product.size}</div>
        <Link to={`/shop/${product.id}`} className="hover:text-ube transition-colors">
          <h3 className="font-serif text-lg font-medium text-gray-900 mb-2 leading-tight">{product.name}</h3>
        </Link>
        
        <div className="mt-auto pt-2 flex items-center justify-between">
          <span className="font-medium text-gray-900">${product.price}</span>
          <div className="flex text-coral text-sm">
            {[...Array(5)].map((_, i) => (
              <SafeIcon key={i} name="Star" className="fill-current w-4 h-4" />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;